import {post} from "../http"

export default {
    example(data) {
        return post('', data)
    }
}